import { useMemo } from 'react';
import {
  type EntityOptions,
  type EntityType,
  type EntityTypeMap,
  makeEntitiesSelector,
  useAppSelector
} from '@wappsto/redux';

export default function useEntitiesSelector<
  T extends EntityType,
  R = EntityTypeMap[T],
>(type: T, options?: EntityOptions): R[] {
  const getEntities = useMemo(() => makeEntitiesSelector(), []);
  return useAppSelector(state => getEntities(state, type, options)) as R[];
}
